/**
 * Torso outfit textures: alien-elemental-2
 */
export function drawTorso_bionic_male(ctx, size, _options = {}) {
  // 3. ÁO GIÁP KIM LOẠI TITAN GHÉP TẤM RÃNH, VI MẠCH XANH NEON, CỔNG CÁP ĐIỆN TỬ (NEON-SYNTHETICA - MALE)
  ctx.fillStyle = '#1e293b';
  ctx.fillRect(0, 0, size, size);

  // Tấm giáp ngực titan ghép rãnh
  ctx.fillStyle = '#334155';
  ctx.strokeStyle = '#0f172a';
  ctx.lineWidth = size * 0.022;

  ctx.beginPath();
  ctx.moveTo(size * 0.12, size * 0.12);
  ctx.lineTo(size * 0.46, size * 0.12);
  ctx.lineTo(size * 0.44, size * 0.48);
  ctx.lineTo(size * 0.16, size * 0.44);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();

  ctx.beginPath();
  ctx.moveTo(size * 0.54, size * 0.12);
  ctx.lineTo(size * 0.88, size * 0.12);
  ctx.lineTo(size * 0.84, size * 0.44);
  ctx.lineTo(size * 0.56, size * 0.48);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();

  // Giáp bụng 4 múi kim loại
  for (let r = 0; r < 2; r++) {
    const yTop = size * (0.54 + r * 0.18);
    ctx.fillStyle = '#273549';
    ctx.fillRect(size * 0.22, yTop, size * 0.24, size * 0.14);
    ctx.strokeRect(size * 0.22, yTop, size * 0.24, size * 0.14);
    ctx.fillRect(size * 0.54, yTop, size * 0.24, size * 0.14);
    ctx.strokeRect(size * 0.54, yTop, size * 0.24, size * 0.14);
  }

  // Vi mạch xanh neon PCB
  ctx.strokeStyle = '#06b6d4';
  ctx.lineWidth = size * 0.018;
  ctx.beginPath();
  ctx.moveTo(size * 0.2, size * 0.2);
  ctx.lineTo(size * 0.32, size * 0.2);
  ctx.lineTo(size * 0.32, size * 0.38);
  ctx.lineTo(size * 0.42, size * 0.38);
  ctx.moveTo(size * 0.8, size * 0.22);
  ctx.lineTo(size * 0.68, size * 0.22);
  ctx.lineTo(size * 0.68, size * 0.4);
  ctx.lineTo(size * 0.78, size * 0.52);
  ctx.lineTo(size * 0.78, size * 0.72);
  ctx.moveTo(size * 0.5, size * 0.5);
  ctx.lineTo(size * 0.5, size * 0.9);
  ctx.stroke();

  // Mắt hàn vi mạch
  ctx.fillStyle = '#67e8f9';
  [
    [0.2, 0.2],
    [0.42, 0.38],
    [0.8, 0.22],
    [0.78, 0.72],
    [0.5, 0.5],
    [0.5, 0.9]
  ].forEach((node) => {
    ctx.beginPath();
    ctx.arc(size * node[0], size * node[1], size * 0.02, 0, Math.PI * 2);
    ctx.fill();
  });

  // Cổng cáp dữ liệu ngực phải
  ctx.fillStyle = '#0f172a';
  ctx.fillRect(size * 0.7, size * 0.28, size * 0.12, size * 0.08);
  ctx.strokeStyle = '#94a3b8';
  ctx.lineWidth = size * 0.01;
  ctx.strokeRect(size * 0.7, size * 0.28, size * 0.12, size * 0.08);
  ctx.fillStyle = '#eab308';
  for (let p = 0; p < 3; p++) {
    ctx.fillRect(size * (0.72 + p * 0.03), size * 0.3, size * 0.016, size * 0.04);
  }

  // Cổng cáp tròn hông trái
  ctx.fillStyle = '#0f172a';
  ctx.beginPath();
  ctx.arc(size * 0.16, size * 0.72, size * 0.045, 0, Math.PI * 2);
  ctx.fill();
  ctx.strokeStyle = '#94a3b8';
  ctx.stroke();
  ctx.fillStyle = '#06b6d4';
  ctx.beginPath();
  ctx.arc(size * 0.16, size * 0.72, size * 0.02, 0, Math.PI * 2);
  ctx.fill();
}

export function drawTorso_bionic_female(ctx, size, _options = {}) {
  // 4. GIÁP BIONIC THANH THOÁT, ĐÈN TÍN HIỆU LED NGỰC (NEON-SYNTHETICA - FEMALE)
  ctx.fillStyle = '#f1f5f9';
  ctx.fillRect(0, 0, size, size);

  // Mảng carbon ôm dáng hai bên sườn
  ctx.fillStyle = '#0f172a';
  ctx.beginPath();
  ctx.moveTo(0, size * 0.15);
  ctx.lineTo(size * 0.18, size * 0.2);
  ctx.quadraticCurveTo(size * 0.24, size * 0.6, size * 0.14, size * 0.88);
  ctx.lineTo(0, size * 0.88);
  ctx.closePath();
  ctx.fill();

  ctx.beginPath();
  ctx.moveTo(size, size * 0.15);
  ctx.lineTo(size * 0.82, size * 0.2);
  ctx.quadraticCurveTo(size * 0.76, size * 0.6, size * 0.86, size * 0.88);
  ctx.lineTo(size, size * 0.88);
  ctx.closePath();
  ctx.fill();

  // Cổ áo bionic vát góc
  ctx.strokeStyle = '#06b6d4';
  ctx.lineWidth = size * 0.015;
  ctx.beginPath();
  ctx.moveTo(size * 0.32, 0);
  ctx.lineTo(size * 0.5, size * 0.18);
  ctx.lineTo(size * 0.68, 0);
  ctx.stroke();

  // Đèn tín hiệu LED ngực
  const ledY = size * 0.4;
  ctx.fillStyle = '#1e293b';
  ctx.beginPath();
  ctx.ellipse(size * 0.5, ledY, size * 0.15, size * 0.12, 0, 0, Math.PI * 2);
  ctx.fill();
  ctx.strokeStyle = '#38bdf8';
  ctx.lineWidth = size * 0.015;
  ctx.stroke();

  ctx.fillStyle = '#06b6d4';
  ctx.beginPath();
  ctx.ellipse(size * 0.5, ledY, size * 0.1, size * 0.08, 0, 0, Math.PI * 2);
  ctx.fill();

  ctx.fillStyle = '#ffffff';
  ctx.beginPath();
  ctx.ellipse(size * 0.5, ledY, size * 0.05, size * 0.04, 0, 0, Math.PI * 2);
  ctx.fill();

  // Vạch tín hiệu LED ngực
  [-1, 1].forEach((side) => {
    for (let b = 0; b < 3; b++) {
      ctx.fillStyle = b === 2 ? '#22d3ee' : '#0891b2';
      ctx.fillRect(size * (0.5 + side * (0.18 + b * 0.035) - 0.012), ledY - size * 0.04, size * 0.02, size * 0.08);
    }
  });

  // Dải truyền dẫn quang học dọc xương ức
  ctx.strokeStyle = '#22d3ee';
  ctx.lineWidth = size * 0.012;
  ctx.beginPath();
  ctx.moveTo(size * 0.5, ledY + size * 0.12);
  ctx.lineTo(size * 0.5, size * 0.85);
  ctx.stroke();

  ctx.fillStyle = '#38bdf8';
  ctx.fillRect(size * 0.38, size * 0.84, size * 0.24, size * 0.03);
}

export function drawTorso_cryo_male(ctx, size, _options = {}) {
  // 5. ÁO TINH THỂ BĂNG PHỦ TUYẾT RẠN NỨT KHÚC XẠ ÁNH SÁNG (CRYONIA - MALE)
  const iceBaseGrad = ctx.createLinearGradient(0, 0, 0, size);
  iceBaseGrad.addColorStop(0, '#0c4a6e');
  iceBaseGrad.addColorStop(0.5, '#0369a1');
  iceBaseGrad.addColorStop(1, '#082f49');
  ctx.fillStyle = iceBaseGrad;
  ctx.fillRect(0, 0, size, size);

  // Mảng đa giác tinh thể băng rạn nứt
  const facets = [
    {
      pts: [
        [0.15, 0.18],
        [0.45, 0.15],
        [0.35, 0.45]
      ],
      fill: 'rgba(56, 189, 248, 0.28)'
    },
    {
      pts: [
        [0.85, 0.18],
        [0.55, 0.15],
        [0.65, 0.45]
      ],
      fill: 'rgba(125, 211, 252, 0.35)'
    },
    {
      pts: [
        [0.5, 0.22],
        [0.65, 0.45],
        [0.5, 0.7],
        [0.35, 0.45]
      ],
      fill: 'rgba(186, 230, 253, 0.40)'
    },
    {
      pts: [
        [0.35, 0.45],
        [0.5, 0.7],
        [0.3, 0.85]
      ],
      fill: 'rgba(2, 132, 199, 0.30)'
    },
    {
      pts: [
        [0.65, 0.45],
        [0.5, 0.7],
        [0.7, 0.85]
      ],
      fill: 'rgba(14, 165, 233, 0.32)'
    }
  ];

  facets.forEach((fc) => {
    ctx.fillStyle = fc.fill;
    ctx.beginPath();
    fc.pts.forEach((p, idx) =>
      idx === 0 ? ctx.moveTo(size * p[0], size * p[1]) : ctx.lineTo(size * p[0], size * p[1])
    );
    ctx.closePath();
    ctx.fill();
    ctx.strokeStyle = '#e0f2fe';
    ctx.lineWidth = size * 0.016;
    ctx.stroke();
  });

  // Đường rạn nứt phụ
  ctx.strokeStyle = '#ffffff';
  ctx.lineWidth = size * 0.012;
  ctx.beginPath();
  ctx.moveTo(size * 0.5, size * 0.22);
  ctx.lineTo(size * 0.5, 0);
  ctx.moveTo(size * 0.35, size * 0.45);
  ctx.lineTo(size * 0.1, size * 0.5);
  ctx.moveTo(size * 0.65, size * 0.45);
  ctx.lineTo(size * 0.9, size * 0.5);
  ctx.stroke();

  // Sương tuyết phủ mờ vai áo
  ctx.fillStyle = 'rgba(248, 250, 252, 0.65)';
  ctx.fillRect(0, 0, size, size * 0.12);
  for (let s = 0; s < 16; s++) {
    const sx = (s * 37) % size;
    const sy = (s * 19) % (size * 0.2);
    ctx.beginPath();
    ctx.arc(sx, sy, size * 0.015, 0, Math.PI * 2);
    ctx.fill();
  }

  // Tinh thể quả trám tâm ngực
  ctx.fillStyle = '#ffffff';
  ctx.beginPath();
  ctx.moveTo(size * 0.5, size * 0.4);
  ctx.lineTo(size * 0.55, size * 0.46);
  ctx.lineTo(size * 0.5, size * 0.52);
  ctx.lineTo(size * 0.45, size * 0.46);
  ctx.closePath();
  ctx.fill();
}

export function drawTorso_cryo_female(ctx, size, _options = {}) {
  // 6. VÁY BĂNG TUYẾT MỜ GRADIENT LAM NHẠT (CRYONIA - FEMALE)
  const cryoGrad = ctx.createLinearGradient(0, 0, 0, size);
  cryoGrad.addColorStop(0, '#f8fafc');
  cryoGrad.addColorStop(0.35, '#e0f2fe');
  cryoGrad.addColorStop(0.7, '#bae6fd');
  cryoGrad.addColorStop(1, '#38bdf8');
  ctx.fillStyle = cryoGrad;
  ctx.fillRect(0, 0, size, size);

  // Cổ áo viền sương băng
  ctx.strokeStyle = '#ffffff';
  ctx.lineWidth = size * 0.02;
  ctx.beginPath();
  ctx.moveTo(size * 0.3, 0);
  ctx.quadraticCurveTo(size * 0.5, size * 0.2, size * 0.7, 0);
  ctx.stroke();

  // Hoa tuyết băng lục giác trước ngực
  const sX = size * 0.5,
    sY = size * 0.36,
    sR = size * 0.14;
  ctx.strokeStyle = 'rgba(255, 255, 255, 0.9)';
  ctx.lineWidth = size * 0.015;
  for (let a = 0; a < 3; a++) {
    const rad = (a * Math.PI) / 3;
    ctx.beginPath();
    ctx.moveTo(sX - Math.cos(rad) * sR, sY - Math.sin(rad) * sR);
    ctx.lineTo(sX + Math.cos(rad) * sR, sY + Math.sin(rad) * sR);
    ctx.stroke();
  }
  ctx.fillStyle = '#ffffff';
  ctx.beginPath();
  ctx.arc(sX, sY, size * 0.035, 0, Math.PI * 2);
  ctx.fill();

  // Đai eo pha lê băng
  ctx.fillStyle = 'rgba(255, 255, 255, 0.75)';
  ctx.fillRect(0, size * 0.6, size, size * 0.08);
  ctx.strokeStyle = '#0284c7';
  ctx.lineWidth = size * 0.01;
  ctx.strokeRect(0, size * 0.6, size, size * 0.08);

  for (let g = size * 0.1; g < size * 0.95; g += size * 0.16) {
    ctx.fillStyle = '#38bdf8';
    ctx.beginPath();
    ctx.arc(g, size * 0.64, size * 0.022, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = '#ffffff';
    ctx.beginPath();
    ctx.arc(g - 2, size * 0.64 - 2, size * 0.008, 0, Math.PI * 2);
    ctx.fill();
  }

  // Rèm nhũ băng gấu váy
  ctx.fillStyle = '#ffffff';
  ctx.beginPath();
  ctx.moveTo(0, size);
  for (let p = 0; p <= 8; p++) {
    const px = (p / 8) * size;
    const py = p % 2 === 0 ? size * 0.88 : size * 0.96;
    ctx.lineTo(px, py);
  }
  ctx.lineTo(size, size);
  ctx.closePath();
  ctx.fill();
}

export function drawTorso_ocean_male(ctx, size, _options = {}) {
  // 7. ÁO VẢY CÁ BIỂN SÂU LẤP LÁNH PHẢN QUANG, VIỀN BỌT SÓNG (AQUATERRA - MALE)
  const oceanGrad = ctx.createLinearGradient(0, 0, 0, size);
  oceanGrad.addColorStop(0, '#0c4a6e');
  oceanGrad.addColorStop(0.6, '#082f49');
  oceanGrad.addColorStop(1, '#021f35');
  ctx.fillStyle = oceanGrad;
  ctx.fillRect(0, 0, size, size);

  // Hàng vảy cá phản quang
  const scaleRows = 6;
  const scaleCols = 5;
  const startY = size * 0.24;
  const rowH = size * 0.11;
  const colW = size * 0.2;

  for (let r = 0; r < scaleRows; r++) {
    const y = startY + r * rowH;
    const xOffset = r % 2 === 0 ? 0 : colW * 0.5;
    for (let c = -1; c <= scaleCols; c++) {
      const x = c * colW + xOffset;
      ctx.fillStyle = r % 2 === 0 ? '#0d9488' : '#0284c7';
      ctx.beginPath();
      ctx.arc(x + colW * 0.5, y, colW * 0.48, 0, Math.PI);
      ctx.fill();

      ctx.strokeStyle = '#2dd4bf';
      ctx.lineWidth = size * 0.014;
      ctx.stroke();

      ctx.fillStyle = '#ccfbf1';
      ctx.beginPath();
      ctx.arc(x + colW * 0.5, y + rowH * 0.45, size * 0.012, 0, Math.PI * 2);
      ctx.fill();
    }
  }

  // Viền bọt sóng cổ áo
  ctx.fillStyle = '#f0fdfa';
  ctx.beginPath();
  ctx.moveTo(0, 0);
  ctx.lineTo(size, 0);
  ctx.lineTo(size, size * 0.16);
  for (let w = size; w >= 0; w -= size * 0.125) {
    ctx.quadraticCurveTo(w - size * 0.0625, size * 0.22, w - size * 0.125, size * 0.16);
  }
  ctx.closePath();
  ctx.fill();
  ctx.strokeStyle = '#99f6e4';
  ctx.lineWidth = size * 0.015;
  ctx.stroke();

  // Ngọc trai biển sâu giữa ngực
  ctx.fillStyle = '#065f46';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.18, size * 0.06, 0, Math.PI * 2);
  ctx.fill();
  ctx.fillStyle = '#f8fafc';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.18, size * 0.04, 0, Math.PI * 2);
  ctx.fill();
}

export function drawTorso_ocean_female(ctx, size, _options = {}) {
  // 8. ÁO LỤA MÀNG VÂY BIỂN ÓNG ÁNH (AQUATERRA - FEMALE)
  const silkGrad = ctx.createLinearGradient(0, 0, size, size);
  silkGrad.addColorStop(0, '#0d9488');
  silkGrad.addColorStop(0.4, '#14b8a6');
  silkGrad.addColorStop(0.7, '#2dd4bf');
  silkGrad.addColorStop(1, '#a855f7');
  ctx.fillStyle = silkGrad;
  ctx.fillRect(0, 0, size, size);

  // Cổ áo hình màng vây vỏ sò
  ctx.fillStyle = 'rgba(255, 255, 255, 0.45)';
  ctx.beginPath();
  ctx.moveTo(size * 0.25, 0);
  ctx.bezierCurveTo(size * 0.35, size * 0.24, size * 0.65, size * 0.24, size * 0.75, 0);
  ctx.closePath();
  ctx.fill();
  ctx.strokeStyle = '#ffffff';
  ctx.lineWidth = size * 0.018;
  ctx.stroke();

  // Vân gân màng vây lụa
  ctx.strokeStyle = 'rgba(255, 255, 255, 0.65)';
  ctx.lineWidth = size * 0.015;
  for (let i = 0; i < 6; i++) {
    const startX = size * (0.2 + i * 0.12);
    ctx.beginPath();
    ctx.moveTo(startX, size * 0.24);
    ctx.quadraticCurveTo(startX + (i % 2 === 0 ? 25 : -25), size * 0.58, startX + (i - 2.5) * 15, size);
    ctx.stroke();
  }

  // Chuỗi ngọc trai biển vắt chéo ngực
  for (let p = 0; p < 8; p++) {
    const px = size * (0.22 + p * 0.08);
    const py = size * (0.25 + p * 0.08);
    ctx.fillStyle = '#f8fafc';
    ctx.beginPath();
    ctx.arc(px, py, size * 0.024, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = '#5eead4';
    ctx.beginPath();
    ctx.arc(px - 1, py - 1, size * 0.01, 0, Math.PI * 2);
    ctx.fill();
  }

  // Bọt nước phát quang
  ctx.fillStyle = 'rgba(240, 253, 250, 0.8)';
  [
    [0.18, 0.5],
    [0.82, 0.45],
    [0.25, 0.85],
    [0.78, 0.82],
    [0.52, 0.7]
  ].forEach((sp) => {
    ctx.beginPath();
    ctx.arc(size * sp[0], size * sp[1], size * 0.018, 0, Math.PI * 2);
    ctx.fill();
  });
}

export const alien_elemental_2_drawers = {
  bionic_male: drawTorso_bionic_male,
  bionic_female: drawTorso_bionic_female,
  cryo_male: drawTorso_cryo_male,
  cryo_female: drawTorso_cryo_female,
  ocean_male: drawTorso_ocean_male,
  ocean_female: drawTorso_ocean_female
};
